
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport04_VDialog extends Serenity.EntityDialog<IcReport04_VRow, any> {
        protected getFormKey() { return IcReport04_VForm.formKey; }
        protected getIdProperty() { return IcReport04_VRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport04_VRow.localTextPrefix; }
        protected getNameProperty() { return IcReport04_VRow.nameProperty; }
        protected getService() { return IcReport04_VService.baseUrl; }
        protected getDeletePermission() { return IcReport04_VRow.deletePermission; }
        protected getInsertPermission() { return IcReport04_VRow.insertPermission; }
        protected getUpdatePermission() { return IcReport04_VRow.updatePermission; }

        protected form = new IcReport04_VForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}